// extracted by mini-css-extract-plugin
module.exports = {"component":"AdminCarCalendar_component__3hWfJ"};